import { render, staticRenderFns } from "./BrandingTab.vue?vue&type=template&id=c0426dc2&scoped=true&"
import script from "./BrandingTab.vue?vue&type=script&lang=js&"
export * from "./BrandingTab.vue?vue&type=script&lang=js&"
import style0 from "./BrandingTab.vue?vue&type=style&index=0&id=c0426dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0426dc2",
  null
  
)

export default component.exports